import Ship from './ship';

class PatrolBoat extends Ship {
  constructor() {
    super(1);
  }
}

export default PatrolBoat;
